import { createStore } from "redux";
import { PullStatus } from "antd-mobile/es/components/pull-to-refresh";
import constant from '../store/constant'

export interface IState {
  refreshStatusDict: Record<PullStatus, string>;
  productInfoDict: Record<string, any>;
  productList: Record<string, any>;
  // productInfo: Record<string, any>;
  productSetting: Record<string, any>;
  accountInfo: Record<string, any>;
  popTextRef: any;
  popConfirmRef: any;
  loginVisible:boolean;
  showQuestion:boolean;
  showOrderInfo:boolean;
  showErrTip:boolean;
  errTipText:string;
  goodsList:Record<string,any>;
  currentOrderInfo:Record<string,any>;
  giftsList:Record<string,any>;
}
export interface IAction {
  type: string;
  data: any;
}

const initialState: IState = {
  // 下拉刷新国际化文案配置项
  refreshStatusDict: {
    pulling: "common.下拉刷新",
    canRelease: "common.释放立即刷新",
    refreshing: "common.加载中...",
    complete: "common.刷新成功",
  },
  productList: {}, //产品列表
  // productInfo:{},//产品信息
  // 产品信息字典
  productInfoDict: {
    20000050: { product_referr: "dy" },   // 盾勇
    20000062: { product_referr: "mt" },   // 我叫MT
    20000052: { product_referr: "zjjh" }, // 再见江湖
    20000036: { product_referr: "yxwd" }, // 英雄无敌
    20000097: { product_referr: "rxjh" }, // 热血江湖
    20000034: { product_referr: "demo" }, // 测试demo
    20000041: { product_referr: "rxqc" }, // 热血江湖青春
    20000083: { product_referr: "z"}, //  Zombiflux
  },
  productSetting: {}, // 产品配置
  accountInfo: {}, //账号信息
  popTextRef: null, // 文字提示框
  popConfirmRef: null, // 确定提示框
  loginVisible:false, // 手机号登录弹窗                 
  showQuestion:false, // 问题弹窗
  showOrderInfo:false, // 订单弹窗
  showErrTip:false, // 错误弹窗
  errTipText:'',  // 错误提示内容
  goodsList:{},   //商品列表
  currentOrderInfo:{}, // 当前订单信息
  giftsList:{}, // 免费礼包
};
const Reducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    // 产品列表
    case "PRODUCTLIST":
      return { ...state, productList: action.data };
    // case "PRODUCTINFO":
    //   return { ...state, productInfo: action.data };
    // 产品配置
    case "PRODUCTSETTING":
      return { ...state, productSetting: action.data };
    // 用户信息
    case "ACCOUNTINFO":
      return { ...state, accountInfo: action.data };
    // 文字提示框
    case "POPTEXTREF":
      return { ...state, popTextRef: action.data };
    // 确定提示框
    case "POPCONFIRMREF":
      return { ...state, popConfirmRef: action.data };
    // 登录弹出框
    case "LOGINVISIBLE":
      return { ...state, loginVisible: action.data };
    case "SHOWQUESTION":
      return { ...state, showQuestion: action.data };
    case "SHOWORDERINFO":
      return { ...state, showOrderInfo: action.data };
    case constant.SHOWERRTIP:
      return { ...state, showErrTip: action.data };
    case constant.ERRTIPTEXT:
      return { ...state, errTipText: action.data };
    case constant.GOODSLIST:
      return { ...state, goodsList: action.data };
    case constant.GIFTSLIST:
      return { ...state, giftsList: action.data };
    default:
      return state;
  }
};

const store = createStore(Reducer);

export default store;
